import { createModel } from "hox";
import { IWarehouseParams, IWarehouseSearch, IWarehouseDetail, IWarehouseInsert, IWarehouseUpdata, IWarehouseDisable } from "./warehouseTypes"
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
import { TablePaginationConfig } from "antd/es/table/interface";
import React, { useState } from "react"
import { filterArrId, Optios, transPgToPagination, forFind, findOption } from "../../../utils/utils"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { PaginationProps } from "antd/es/pagination";
import { globalPrompt } from "../../../components2/YhMessage"
import { warehouseService } from "./warehouseService"
import useMdmModel from "../../../model/mdmModel"

export const useWarehouseModel = createModel(function () {
    const { mdmOrgan } = useMdmModel();

    const initSearchParams: IWarehouseParams = {}
    const initDataSource: IWarehouseDetail[] = []
    const initAddParam: IWarehouseInsert = { enable: true, branch: "main" }
    const initPage: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IWarehouseParams>(initSearchParams)
    //列表数据
    const [dataSource, setDataSource] = useState<IWarehouseDetail[]>(initDataSource);
    //分页参数
    const [page, setPage] = useState<TablePaginationConfig>(initPage);
    //表格选中行key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    ////表格选中行的数据
    const [selectedRow, setSelectedRow] = useState<IWarehouseDetail[]>([]);
    //新增参数
    const [addParam, setAddParam] = useState<IWarehouseInsert>(initAddParam);
    //仓库类型
    const [warehouseType, setWarehouseType] = useState<Optios[]>([]);

    const upDataSearchParam = (upDataParam: IWarehouseParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = async () => {
        await setSearchParam(initSearchParams)
        const resetPage = { pageSize: 15, pageNum: 1 }
        await loadData(resetPage, initSearchParams)
    }
    const loadData = async (pages?: ISearchPage, data?: IWarehouseParams) => {
        const searchParams = data ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: pages?.pageSize ?? page.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: pages?.pageNum ?? page.current ?? DEFAULT_FIRST_PAGE_NUM
            }
        }
        const { retData } = await warehouseService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDataSource(records)
    }
    const updataAddParam = (updateParam: IWarehouseInsert) => {
        let newUpdateParam = updateParam
        if ("orgCode" in updateParam) {
            console.log(updateParam.orgCode,mdmOrgan)
            let findItem = forFind(mdmOrgan,updateParam.orgCode as string,"code")
            newUpdateParam = { ...updateParam, orgName: findItem?.name as string }
        }
        if ("typeCode" in updateParam) {
            let findItem = findOption(updateParam.typeCode as string, warehouseType)
            console.log(findItem, warehouseType)
            newUpdateParam = { ...updateParam, typeName: findItem?.label as string }
        }
        setAddParam({ ...addParam, ...newUpdateParam })
    }
    const updataEditParam = (updateParam: IWarehouseDetail) => {
        let newUpdateParam = updateParam
        if ("orgCode" in updateParam) {
            let findItem = forFind(mdmOrgan, updateParam.orgCode as string,)
            newUpdateParam = { ...updateParam, orgName: findItem?.name as string }
        }
        if ("typeCode" in updateParam) {
            let findItem = findOption(updateParam.typeCode as string, warehouseType)
            newUpdateParam = { ...updateParam, typeName: findItem?.label as string }
        }
        setSelectedRow([{ ...selectedRow[0], ...newUpdateParam }])
    }
    const insertDetail = async (params: IWarehouseInsert) => {
        const param = {
            ...addParam,
            sourceApp: "mdm",
            enable: addParam.enable ? 1 : 0
        }
        const { retData, retMsg } = await warehouseService.insert(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const updataDetail = async (params: IWarehouseDetail) => {
        const param = {
            ...selectedRow[0],
            enable: params.enable ? 1 : 0
        }
        const { retData, retMsg } = await warehouseService.update(param)
        globalPrompt("message", { type: "success", text: retMsg })
        return retData
    }
    const cutDisabled = async (params: IWarehouseDetail, checked: boolean) => {
        const param = {
            ...params,
            enable: checked ? 1 : 0
        }
        const { retData, retMsg } = await warehouseService.update(param)
        await globalPrompt("message", { type: "success", text: "修改完成" })
        await loadData()
    }
    return {
        searchParam,
        dataSource,
        page,
        selectedRow,
        selectedRowKeys,
        addParam,
        warehouseType,
        setSearchParam,
        setDataSource,
        setPage,
        setSelectedRowKeys,
        setSelectedRow,
        upDataSearchParam,
        resetSearchParam,
        loadData,
        setAddParam,
        updataAddParam,
        updataEditParam,
        insertDetail,
        updataDetail,
        cutDisabled,
        setWarehouseType
    }
});